import { DEFAULT_AMOUNT, DEFAULT_TERM } from 'utils/constants';
import { Link } from 'components/atoms';
import { useErrorManager } from 'InternalLibrary';
import { useLegalTerms } from 'hooks/useLegalTerms';
import { useTranslation } from 'react-i18next';
import Modal from 'components/molecules/Modal/Modal';
import React, { memo, PropsWithChildren, useEffect, useState } from 'react';
import styles from './LegalTermsModal.module.scss';
import useApplication from 'hooks/useApplication';

export type Props = {
  amount?: number;
  term?: number;
  onClose: () => void;
};

export default memo(function LegalTermsModal({
  amount,
  term,
  onClose,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation('registration_header');
  const { setError } = useErrorManager();
  const { getLegalTerms, printLegalTerms } = useLegalTerms();
  const { data: application } = useApplication();
  const [content, setContent] = useState<string | undefined>(undefined);

  const amountParam = String(amount || application?.amount || DEFAULT_AMOUNT);
  const termParam = String(term || application?.term || DEFAULT_TERM);

  const handleLegalContent = async () => {
    try {
      const data = await getLegalTerms(amountParam, Number(termParam));
      setContent(data as string);
    } catch (e) {
      setError(e);
    }
  };

  useEffect(() => {
    handleLegalContent();
  }, [amount, term, application?.amount, application?.term]);

  return (
    <Modal
      className={styles.modal}
      isOpen
      onClose={onClose}
      title={t('title_modal')}
    >
      {content && (
        <>
          <div
            className={styles.content}
            data-test="legal-terms-content"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
          <Link
            className={styles.download}
            dataTest="legal-terms-link"
            disabled={!content}
            onClick={() => printLegalTerms(content)}
          >
            {t('common:download')}
          </Link>
        </>
      )}
    </Modal>
  );
});
